import {checkPermission} from "~/components/context/userContext/helpers/checkPermission";

export  const checkMultiplePermissions = (permissions, actions) => {
    if(permissions.length && actions.length){
        return !!permissions.every(p => checkPermission(p, actions));
    }
}